import React, { useEffect, useState } from "react";
import {
  Button,
  Card,
  Col,
  FloatingLabel,
  Form,
  OverlayTrigger,
  Row,
  Spinner,
  Tooltip,
} from "react-bootstrap";
import { default as Modal2, default as Toast } from "react-bootstrap/Modal";
import { useTranslation } from "react-i18next";
import { BiBadgeCheck } from "react-icons/bi";
import { GoProject } from "react-icons/go";
import { GrUserExpert } from "react-icons/gr";
import { MdOutlineLanguage } from "react-icons/md";
import Modal from "react-modal";
import { useLocation, useNavigate } from "react-router-dom";
import { vasthuUrl } from "../component/Api";
import { UseConsultant } from "../context/ConsultantContext";
import BillDeskPay from "./BillDeskPay";
import FreeUsed from "./FreeUsed";
import ReviewBadge from "./ReviewBadge";
import ToastMsg from "./Toast";
import UserDetailModal from "./UserDetailModal";
import FreeImg from "../images/free_calls.png";
import WalletImg from "../images/min_call.png";
import FixedDuration from "../images/fix_call.png";
import BgImg from "../images/Image only22.png";
import { IoCall } from "react-icons/io5";
import { PiPhoneCallDuotone } from "react-icons/pi";
import UpBtn from "../images/uparrow.gif"

const ConsultantDetails = () => {
  const {
    setAlertFunction,
    chatAlertCall,
    handleWalletCall,
    handleFreeCall,
    walletBalance,
    setWalletBalance,
  } = UseConsultant();
  // const walletBalance = wallet && wallet.balance;
  const { t, i18n } = useTranslation();
  const location = useLocation();
  console.log("location", location);
  const navigate = useNavigate();
  const lang = window.localStorage.getItem("i18nextLng");
  const userId = window.sessionStorage.getItem("userId");
  const token = window.sessionStorage.getItem("token");
  const consultantId = window.sessionStorage.getItem("consultantId");
  const uuid = window.sessionStorage.getItem("userId");
  const duration = window.sessionStorage.getItem("AudioCallDuration");
  const [profList, setProfList] = useState([]);
  console.log("profList", profList);

  const [callStatusPro, setCallStatusPro] = useState();
  const [waitingTime, setWaitingTime] = useState();
  const [consulName, setConsulName] = useState();
  const [selectedConsultant, setSelectedConsultant] = useState({});
  const [selectedConsultantService, setSelectedConsultantService] = useState();
  // service
  const [defaultAudioOffer, setDefaultAudioOffer] = useState({});
  const [defaultAudioOffer15, setDefaultAudioOffer15] = useState({});
  const [defaultAudioOffer30, setDefaultAudioOffer30] = useState({});
  let subtitle;
  const [loading, setLoading] = useState(false);
  const [selectedAudioOffer, setSelectedAudioOffer] = useState(7);
  const [activeServiceList, setActiveServiceList] = useState([]);
  const [serviceData, setServiceData] = useState([]);
  const [consultantServiceList, setConsultantServiceList] = useState([]);
  const [defaultHomeOffer, setDefaultHomeOffer] = useState({
    offerId: 0,
    offerPrice: 0,
    serviceId: 0,
  });
  const [formData, setFormData] = useState({
    duration: 0,
    price: 0,
  });
  const [freeCallStatus, setFreeCallStatus] = useState("");
  console.log("profList", profList);
  const [bookingStatus, setBookingStatus] = useState("");
  const [loadingId, setLoadingId] = useState(null);

  console.log("consultantId", consultantId);

  const { consultantUuid } = location.state || {};
  const ConsultantData = location?.state || null;
  console.log("ConsultantData", ConsultantData);

  useEffect(() => {
    setAlertFunction(alert);
  }, [setAlertFunction]);

  // ALERT MODAL
  const [message, setMessage] = useState("");
  const [messageType, setMessageType] = useState("");
  const [toastTrigger, setToastTrigger] = useState(0);

  // const alert = (msg) => {
  //   setMessage(msg);
  //   setToastTrigger((prev) => prev + 1);
  // };

  //modal inside show image 
  const [walletAmount, setWalletAmount] = useState(0);
  const [talkTime, setTalkTime] = useState(0);

  const getWalletBalance = async (ratePerMin) => {

    try {

      const res = await vasthuUrl.post(
        "vasthu/check-call-eligibility",
        {
          userUuid: userId,
          proUuid: sessionStorage.getItem("consultantId"),
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      const balance = res.data.balance ?? res.data.walletBalance ?? 0;

      const rate = Number(ratePerMin) || 10; // fallback safe rate

      const minutes = Math.floor(balance / rate);

      setWalletAmount(balance);
      setTalkTime(minutes);

    } catch (error) {
      console.log("Wallet fetch error:", error);
    }
  };


  const alert = (msg, type) => {
    setMessage(msg);
    setMessageType(type);
    setToastTrigger((prev) => prev + 1);
  };

  // Consultant Busy MODAL
  const [toast, setToast] = useState(false);

  const openToastModal = (value) => {
    setToast(true);
    // setWaitingTime(Math.round(value.waitingTime));
    setWaitingTime(value);
  };

  const closeTosastBtn = () => {
    setToast(false);
    window.sessionStorage.removeItem("pendingAction");
  };

  //Audio call duration MODAL
  const [modalIsOpen, setIsOpen] = React.useState(false);

  function openModal() {
    setIsOpen(true);
  }

  function afterOpenModal() {
    console.log("afterOpenModal");
  }

  function closeModal() {
    setIsOpen(false);
    window.sessionStorage.removeItem("pendingAction");
  }

  //Service MODAL
  const [serviceModal, setServiceModal] = React.useState(false);

  function OpenServiceModal() {
    setServiceModal(true);
  }

  function afterServiceModal() {
    console.log("afterOpenModal");
  }

  function closeServiceModal() {
    setServiceModal(false);
    window.sessionStorage.removeItem("pendingAction");
  }

  //Check Booking Status
  const [checkBookStatus, setCheckBookStatus] = useState(false);

  const openCheckBookStatus = () => {
    setCheckBookStatus(true);
  };

  const closeCheckBookStatus = () => {
    setCheckBookStatus(false);
    window.sessionStorage.removeItem("pendingAction");
  };

  //Check Booking Status
  const [callType, setCallType] = useState(false);

  const openCallType = () => {
    setCallType(true);
  };

  const closeCallType = () => {
    setCallType(false);
    window.sessionStorage.removeItem("pendingAction");
  };

  const [consultantUuids, setConsultantUuids] = useState(null);
  console.log("consultantUuids", consultantUuids);

  //Free Service Used Modal
  const [usedFreeModal, setUsedFreeModal] = useState(0);

  //Free User Details Modal
  const [userDetailsModal, setUserDetailsModal] = useState(0);

  // booking - end
  useEffect(() => {
    vasthuUrl
      .get(`offer/defaultIndividualOffer/audio`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then((res) => {
        console.log("audiores", res);
        setDefaultAudioOffer({
          offerId: res.data.id,
          offerPrice: res.data.offerPrice,
        });
      })
      .catch((err) => setDefaultAudioOffer({}));

    vasthuUrl
      .get(`offer/defaultIndividualOffer/audio15`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then((res) => {
        console.log("audiores15", res);
        setDefaultAudioOffer15({
          offerId: res.data.id,
          offerPrice: res.data.offerPrice,
        });
      })
      .catch((err) => setDefaultAudioOffer15({}));

    vasthuUrl
      .get(`offer/defaultIndividualOffer/audio30`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then((res) => {
        console.log("audiores30", res);
        setDefaultAudioOffer30({
          offerId: res.data.id,
          offerPrice: res.data.offerPrice,
        });
      })
      .catch((err) => setDefaultAudioOffer30({}));
  }, []);

  useEffect(() => {
    setLoading(true);
    if (token) {
      try {
        vasthuUrl
          .get(`/vasthu/getvasthuservices`, {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          })
          .then((res) => {
            console.log("services_list" + res.data);
            let consultations = res.data.filter(
              (obj) => obj.serviceType == "CONSULTATION",
            );
            console.log(
              "services_list_consultaions" + consultations[0].serviceType,
            );
            setServiceData(consultations);
          });

        vasthuUrl
          .get(`/info/professional/consultantdetails`, {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          })
          .then((res) => {
            setProfList(res.data);
            setLoading(false);
          });
      } catch (e) {
        alert("SERVER ERROR");
        setMessageType("error");
        setLoading(false);
      }
    } else {
      setLoading(false);
    }
  }, [token]);

  const executePendingAction = () => {
    const pendingAction = window.sessionStorage.getItem("pendingAction");
    const consultantId = window.sessionStorage.getItem("consultantId");
    const consultantName = window.sessionStorage.getItem("consultantName");
    const consultantType = window.sessionStorage.getItem("consultantType");
    const userId = window.sessionStorage.getItem("userId");

    if (!pendingAction || !consultantId || !consultantType) return;

    setConsulName(consultantName);

    if (pendingAction === "ConsultantHomeBook") {
      getConsutantServices(consultantId);
      window.sessionStorage.removeItem("pendingAction");
    } else if (pendingAction === "HomeChatorCall") {
      if (consultantType === "freeCall" || consultantType === "freeChat") {
        CheckFreeStatus(consultantId, consultantType);
      } else {
        getCallAndChatService(userId, consultantId, consultantType);
      }
      window.sessionStorage.removeItem("pendingAction");
    }
  };


  useEffect(() => {
    if (!ConsultantData) {
      const storedId = sessionStorage.getItem("consultantId");

      if (storedId && token) {
        vasthuUrl
          .get(`/info/professional/${storedId}`, {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          })
          .then((res) => {
            console.log("Fetched consultant after login", res.data);
            setProfList([res.data]); // store it
          })
          .catch((err) => {
            console.log("Consultant fetch error", err);
          });
      }
    }
  }, [token]);



  useEffect(() => {
    if (window.sessionStorage.getItem("token")) {
      executePendingAction();
    }
  }, []);

  useEffect(() => {
    if (userId !== null) {
      try {
        vasthuUrl
          .get(`/vasthu/user/getuserfreecallstatus/${userId}`, {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          })
          .then((res) => {
            setFreeCallStatus(res.data.freeCallUsed);
            if (res.data.freeCallUsedstatus == "Completed") {
              setUsedFreeModal((prev) => prev + 1);
            }
          });
      } catch (e) {
        console.log("service", e);
      }
    }
  }, [userId]);

  const checkLoginAndGetConsultant = (id, name, type, rate) => {
    window.sessionStorage.setItem("consultantId", id);
    window.sessionStorage.setItem("consultantName", name);
    window.sessionStorage.setItem("consultantRate", rate);
    window.sessionStorage.setItem("consultantType", type);
    if (window.sessionStorage.getItem("token") == null) {
      if (type == "Book") {
        window.sessionStorage.setItem("pendingAction", "ConsultantHomeBook");
      } else if (
        type == "Call" ||
        type == "Chat" ||
        type == "freeCall" ||
        type == "freeChat"
      ) {
        window.sessionStorage.setItem("pendingAction", "HomeChatorCall");
      }
      alert(t("USR.LOG.MSG"));
      setMessageType("error");
      setTimeout(() => {
        setLoadingId(null);
        navigate("/login");
      }, 3000);
    } else {
      if (type === "freeCall" || type === "freeChat") {
        CheckFreeStatus(id, type);
      } else if (type === "Chat") {
        getCallAndChatService(userId, id, type);
      } else if (type === "Book") {
        getConsutantServices(id);
      }
      setConsulName(name);
      setLoadingId(null);
    }
  };

  const getCallAndChatService = (userId, consultantId, type) => {
    vasthuUrl
      .post(
        `vasthu/check-call-eligibility`,
        {
          userUuid: userId,
          proUuid: consultantId,
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        },
      )
      .then((res) => {
        console.log("res.data", res.data);

        const status = res.data.status;

        // 🔴 CONSULTANT BUSY
        if (status === "CONSULTANT_IN_CALL") {
          openToastModal(res.data.expectedToBeFreeInMinutes);
          return;
        }

        // 🟡 DONT CALL (Booking restriction)
        if (status === "DONT_CALL") {
          setBookingStatus(res.data);
          openCheckBookStatus();
          return;
        }

        // 🔵 INSUFFICIENT BALANCE
        if (status === "INSUFFICIENT_BALANCE") {
          // ✅ FREE CALL → Ignore balance
          if (type === "freeCall" || type === "freeChat") {
            CheckFreeStatus(consultantId, type);
            return;
          }

          // ❌ Paid call → show wallet
          if (res.data.balance === 0) {
            alert(t("USR.INSF.BAL.ALRT.MSG"));
          } else {
            alert(
              `${t("USR.BAL.MINCOST.CONST.ALT")} ₹${res.data.amountNeeded} ${t(
                "USR.THIS.CONSULTANT",
              )}.`,
            );
          }

          setMessageType("error");

          window.sessionStorage.setItem("consultantId", consultantId);
          window.sessionStorage.setItem("consultantType", type);
          window.sessionStorage.setItem("returnurl", location.pathname);
          window.sessionStorage.setItem("pendingAction", "HomeChatorCall");

          setTimeout(() => {
            window.sessionStorage.removeItem("pendingAction"); // 🔥 ADD THIS
            navigate("/walletoffer");
          }, 3000);

          return;
        }

        // 🟢 CALL ALLOWED
        if (status === "CALL_ALLOWED") {
          if (type === "Chat") {
            setUserDetailsModal((prev) => prev + 1);
            return;
          }

          if (type === "Call") {
            handleWalletCall(); // Paid Call
            return;
          }

          if (type === "Duration") {
            openModal(); // Duration modal
            return;
          }

          if (type === "freeCall" || type === "freeChat") {
            CheckFreeStatus(consultantId, type);
            return;
          }
        }
      })
      .catch((error) => {
        console.log("Eligibility error:", error);
      });
  };

  const handleProceed = () => {
    const consultantType = window.sessionStorage.getItem("consultantType");
    const country = window.sessionStorage.getItem("country");

    if (consultantType == "Chat") {
      setUserDetailsModal((prev) => prev + 1);
    } else {
      // handleWalletCall(); //Limited Duration
      if (country == "0") {
        handleWalletCall(); //Limited Duration
      } else {
        setUserDetailsModal((prev) => prev + 1);
      }
    }
    closeCheckBookStatus();
  };

  const handleProceedCall = (type) => {
    const consultantId = window.sessionStorage.getItem("consultantId");
    if (!consultantId) return;

    if (type === "free") {
      getCallAndChatService(userId, consultantId, "freeCall");
    } else if (type === "wallet") {
      getCallAndChatService(userId, consultantId, "Call");
    } else if (type === "duration") {
      getCallAndChatService(userId, consultantId, "Duration");
    }

    closeCallType();
  };

  useEffect(() => {
    if (location.state?.openCallModal) {
      sessionStorage.setItem("consultantId", location.state.consultantId);
      sessionStorage.setItem("consultantName", location.state.consultantName);

      openCallType();

      // 🔥 Clear navigation state
      navigate(location.pathname, { replace: true });
    }
  }, []);

  useEffect(() => {
    const shouldOpen = sessionStorage.getItem("openCallModal");

    if (shouldOpen === "true") {
      sessionStorage.removeItem("openCallModal");
      openCallType();
    }
  }, []);

  // const handleProceedCall = (type) => {
  //   const country = window.sessionStorage.getItem("country");

  //   if (type == "duration") {
  //     setTimeout(() => {
  //       openModal();
  //     }, 5000);
  //   } else if (type == "wallet") {
  //     if (country == "0") {
  //       handleWalletCall();
  //     } else {
  //       setUserDetailsModal((prev) => prev + 1);
  //     }
  //     // handleWalletCall(); // Wallet Call
  //   }
  //   closeCallType();
  // };

  const CheckFreeStatus = (id, type) => {
    window.sessionStorage.removeItem("pendingAction");

    vasthuUrl
      .get(`/vasthu/user/getuserfreecallstatus/${userId}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then((res) => {
        const freeCallUsed = res.data.freeCallUsed;

        if (freeCallUsed) {
          setUsedFreeModal((prev) => prev + 1);
          return;
        }

        if (type === "freeCall") {
          handleFreeCall(); // 🔥 direct call
        } else if (type === "freeChat") {
          setUserDetailsModal((prev) => prev + 1);
        }
      })
      .catch((err) => {
        console.log("Free call error:", err);
      });
  };

  const getConsutantServices = (uuid) => {
    try {
      vasthuUrl
        .get(`vasthu/getvasthuservicesbyconsultant/${uuid}`, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        })
        .then((res) => {
          console.log("services_list" + res.data);
          setConsultantServiceList(res.data);
          setSelectedConsultant(uuid);
          if (selectedConsultantService == null) {
            OpenServiceModal();
          } else {
            CheckConsultant(uuid);
          }
        });
    } catch (e) {
      console.log("service", e);
    }
  };

  const CheckConsultant = (uuid) => {
    window.sessionStorage.removeItem("pendingAction");
    if (typeof selectedConsultantService !== "undefined") {
      let value = profList.find(
        (x) => x.consultantUuid == (selectedConsultant || uuid),
      );
      window.sessionStorage.setItem(
        "consultantDetail",
        JSON.stringify({ value }),
      );
      navigate("/customerpricing", { state: selectedConsultantService });
    } else {
      alert("Please Select a service");
      setMessageType("error");
    }
  };

  const payHandler = (txn) => {
    console.log("pay response out", txn);
    vasthuUrl
      .post(
        "vasthu/user/bdpaymentresponseui",
        { txn: txn.txnResponse.transaction_response },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        },
      )
      .then((res) => {
        console.log("txnres", res.data);
        if (res.data.transaction_error_type === "success") {
          console.log("Saving payment_response ....", txn);

          vasthuUrl
            .post("vasthu/user/bdpaymentresponsehandler", txn, {
              headers: {
                Authorization: `Bearer ${token}`,
              },
            })
            .then((res) => console.log("after txnsave", res.data))
            .catch((err) => console.log("after txnsave try", err));

          console.log("buying .. subsc");

          setTimeout(() => {
            vasthuUrl
              .post(
                "subscription/buyVasthuOffer",
                {
                  orderId: res.data.orderid,
                  userUuid: userId,
                  offerId: selectedAudioOffer,
                  paymentStatus: true,
                },
                {
                  headers: {
                    Authorization: `Bearer ${token}`,
                  },
                },
              )
              .then((res) => {
                console.log("Payment status changed to true");
                console.log("call audio");
                console.log("afterbuysubscr", res.data);
                try {
                  vasthuUrl.post(
                    `vasthu/user/clicktocall`,
                    {
                      from: consultantId, //"09790580304",
                      to: uuid, //"07092758264",
                      duration: parseInt(duration), //30min
                      subscriptionId: res.data.id,
                    },
                    {
                      headers: {
                        Authorization: `Bearer ${token}`,
                      },
                    },
                  );
                  console.log("postresponsefrom audio call", res.data);
                  console.log("postresponsefrom audio call", res);
                  if (res.status == 200) {
                    navigate("/audiocallstatus", {
                      state: { callStatus: "USR.CAL.PROCED.BTN" },
                    });
                    console.log(
                      "offerId - on 200 [already register offer] status",
                      res.data.id,
                    );
                    vasthuUrl
                      .get(
                        // `/subscription/useVasthuOffer/${i.id}`,
                        `/subscription/useVasthuOffer/${res.data.id}`,
                        {
                          headers: {
                            Authorization: `Bearer ${token}`,
                          },
                        },
                      )
                      .then((rs) =>
                        console.log(
                          "offer subscription redeem count used",
                          rs.data.message,
                        ),
                      )
                      .catch((er) =>
                        console.log(
                          "offer subscription redeem count not reduced",
                          er,
                        ),
                      );
                  } else {
                    navigate("/audiocallstatus", {
                      state: { callStatus: "USR.CAL.FAILD.BTN" },
                    });
                  }
                } catch (err) {
                  console.log("SERVER ERROR", err);
                }
              });
          }, 1000);
        } else {
          vasthuUrl
            .post(
              "subscription/buyVasthuOffer",
              {
                orderId: res.data.orderid,
                userUuid: userId,
                offerId: selectedAudioOffer,
                paymentStatus: false,
              },
              {
                headers: {
                  Authorization: `Bearer ${token}`,
                },
              },
            )
            .then((res) => {
              console.log("Payment status changed to false");
            });
        }
      });
  };

  const handleBuy1 = async () => {
    try {

      console.log("handle_buy1");

      const res = await vasthuUrl.post(
        `vasthu/openapi/createorderapi`,
        {
          userUuid: userId,
          offerId: selectedAudioOffer,
          price: formData.price,
          currency: "356",
          returnUrl: "paymentstatusbilldesk",
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      console.log("billDesk", res.data);

      const config = await BillDeskPay(res.data, payHandler);
      window.loadBillDeskSdk(config);

    } catch (error) {

      console.log("API ERROR:", error);

      if (error.response?.status === 500) {
        alert("Server error. Please try again later.");
        setMessageType("error");
      } else {
        alert("Something went wrong. Please try again.");
        setMessageType("error");
      }

      setLoading(false);
    }
  };

  const handlePsumbit1 = async () => {
    setLoading(true);

    try {
      const list = await vasthuUrl.get(
        `/subscription/userActiveOffers/${userId}`,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );

      let filteredAudioList = list.data.filter((obj) => obj.offerId > 2);

      setActiveServiceList(filteredAudioList);

      console.log("no subscription - please proceed with pay");


      handleBuy1();         // ✅ BillDesk open
      closeCallType();      // ✅ modal close here

    } catch (e) {
      alert("CHECK INTERNET CONNECTION");
      setMessageType("error");
      setLoading(false);
    }
  };

  // const handleDurationRadio = (e) => {
  //   if (e.target.value === "15") {
  //     window.sessionStorage.setItem("AudioCallDuration", String(900));
  //     setSelectedAudioOffer(defaultAudioOffer15.offerId);
  //     setFormData({
  //       duration: e.target.value,
  //       price: defaultAudioOffer15.offerPrice,
  //     });
  //   } else if (e.target.value === "30") {
  //     window.sessionStorage.setItem("AudioCallDuration", String(1800));
  //     setSelectedAudioOffer(defaultAudioOffer30.offerId);
  //     setFormData({
  //       duration: e.target.value,
  //       price: defaultAudioOffer30.offerPrice,
  //     });
  //   } else {
  //     window.sessionStorage.setItem("AudioCallDuration", String(3600));
  //     setSelectedAudioOffer(defaultAudioOffer.offerId);
  //     setFormData({
  //       duration: e.target.value,
  //       price: defaultAudioOffer.offerPrice,
  //     });
  //   }
  // };

  const handleDurationRadio = (value) => {

    if (value === 15) {

      window.sessionStorage.setItem("AudioCallDuration", String(900));

      setSelectedAudioOffer(defaultAudioOffer15.offerId);

      setFormData({
        duration: value,
        price: defaultAudioOffer15.offerPrice,
      });

    } else if (value === 30) {

      window.sessionStorage.setItem("AudioCallDuration", String(1800));

      setSelectedAudioOffer(defaultAudioOffer30.offerId);

      setFormData({
        duration: value,
        price: defaultAudioOffer30.offerPrice,
      });

    } else {

      window.sessionStorage.setItem("AudioCallDuration", String(3600));

      setSelectedAudioOffer(defaultAudioOffer.offerId);

      setFormData({
        duration: value,
        price: defaultAudioOffer.offerPrice,
      });


    }
    setTimeout(() => {
      handlePsumbit1();
    }, 100);
  };

  useEffect(() => {
    if (callType) {
      getWalletBalance(ConsultantData?.ratePerMin);
    }
  }, [callType]);

  return (
    <div>
      <ToastMsg msg={message} type={messageType} trigger={toastTrigger} />
      <FreeUsed usedFreeModal={usedFreeModal} walletBalance={walletBalance} />
      <UserDetailModal userDetailsModal={userDetailsModal} />

      <Modal2
        show={modalIsOpen}
        backdrop="static"
        keyboard={false}
        onHide={closeModal}
        className="all_border"
        centered
      >
        <Modal2.Header closeButton className="all_background">
          <h3>Audio Call Duration</h3>
        </Modal2.Header>
        <h3
          className="text-center mt-3"
          ref={(_subtitle) => (subtitle = _subtitle)}
        >
          {t("TXT.SEL.AUD.CAL.DURA.LO")}
        </h3>
        <form onSubmit={handlePsumbit1}>
          <div
            className="text-center"
            style={{
              display: "flex",
              flexDirection: "column",
              marginBottom: "10px",
            }}
          >
            <div>
              <label>15 {t("TXT.MIN.LO")}</label>
              {/*  15 min */}
              <input
                type="radio"
                name="duration"
                value={15}
                onChange={handleDurationRadio}
                style={{ marginLeft: "revert" }}
              />
            </div>
            <div>
              <label>30 {t("TXT.MIN.LO")}</label>
              {/*  30 min */}
              <input
                type="radio"
                name="duration"
                value={30}
                onChange={handleDurationRadio}
                style={{ marginLeft: "revert" }}
              />
            </div>
            {/* <input type="submit" /> */}
          </div>
          <Modal2.Footer
            style={{
              display: "flex",
              justifyContent: "space-evenly",
              padding: "5px",
            }}
            className="all_border"
          >
            <Button size="sm" type="submit" className="all_btn">
              {t("USR.VFP.DRP.BTN.SMT")}
            </Button>
            <Button size="sm" onClick={closeModal} className="all_btn">
              {t("TXT.BTN.CAN.LO")}
            </Button>
          </Modal2.Footer>
        </form>
      </Modal2>

      <Modal
        isOpen={serviceModal}
        onAfterOpen={afterServiceModal}
        onRequestClose={closeServiceModal}
        // style={customStyles}
        contentLabel="Select Consultaion Service"
      >
        <h2
          className="text-center all_background"
          ref={(_subtitle) => (subtitle = _subtitle)}
        >
          {t("TXT.SEL.SER.LO")}
        </h2>

        <div
          className="text-center"
          style={{ display: "flex", flexDirection: "column" }}
        >
          <FloatingLabel controlId="min">
            <Form.Select
              aria-label="min"
              size="sm"
              className="form_feild"
              onChange={(e) => {
                console.log("SelectedConsultationService", e.target.value);
                setSelectedConsultantService(e.target.value);
              }}
            >
              <option>{t("TXT.SEL.SER.LO")}</option>
              {consultantServiceList.map((service, index) => (
                <option key={index} value={service.id}>
                  {lang == "en"
                    ? service.serviceName
                    : lang == "ta"
                      ? service.serviceNameTamil
                      : service.serviceNameHindi}
                </option>
              ))}
            </Form.Select>
          </FloatingLabel>

          <Button
            size="sm"
            type="submit"
            className="all_btn"
            style={{ width: "100%", marginTop: "8px" }}
            onClick={CheckConsultant}
          >
            {t("USR.VFP.DRP.BTN.SMT")}
          </Button>
        </div>
        <center>
          <Button
            size="sm"
            style={{ width: "100%", marginTop: "8px" }}
            onClick={closeServiceModal}
            className="all_btn"
          >
            {t("TXT.BTN.CAN.LO")}
          </Button>
        </center>
      </Modal>

      <Toast
        show={toast}
        backdrop="static"
        keyboard={false}
        onHide={() => setToast(false)}
        className="all_border"
      >
        <Toast.Header closeButton className="all_background">
          {t("TXT.CON.BSY.LO")}!!!
        </Toast.Header>
        <Toast.Body>
          Hello! <b>{consulName}</b> is currenty busy on another call, please
          bear with us for {waitingTime} minutes{" "}
        </Toast.Body>
        <Toast.Footer>
          <Button className="all_btn" onClick={closeTosastBtn}>
            {t("TXT.CLO.LO")}
          </Button>
        </Toast.Footer>
      </Toast>

      <Modal2
        show={checkBookStatus}
        backdrop="static"
        keyboard={false}
        onHide={closeCheckBookStatus}
      >
        <Modal2.Header className="all_background" closeButton>
          <Modal2.Title>{t("USR.BSY.ALT")}</Modal2.Title>
        </Modal2.Header>
        <Modal2.Body>
          <div>
            {bookingStatus.status === "DONT_CALL" &&
              bookingStatus.allowedTalkTime > 0 ? (
              <>
                {t("USR.THIS.CON.BUSY.TEXT")}{" "}
                <b>{bookingStatus.allowedTalkTime}</b>{" "}
                {t("USR.CONS.CALCOMG.MSG")}
              </>
            ) : (
              t("USR.DONT.CL.MSG")
            )}
          </div>
        </Modal2.Body>
        <Modal2.Footer className="d-flex justify-content-evenly">
          <Button className="all_btn1" onClick={closeCheckBookStatus}>
            {t("TXT.CLO.LO")}
          </Button>

          {bookingStatus.status == "DONT_CALL" &&
            bookingStatus.allowedTalkTime > 0 ? (
            <Button className="all_btn1" onClick={() => handleProceed()}>
              {t("USR.BOK.UR.PLN.PRCED")}
            </Button>
          ) : null}
        </Modal2.Footer>
      </Modal2>

      <Modal2
        show={callType}
        backdrop="static"
        keyboard={false}
        onHide={closeCallType}
        centered
        fullscreen
      >
        <Modal2.Header closeButton className="all_background">
          <h3 className="mb-0">{t("USR.ALERT.HEAD")}</h3>
        </Modal2.Header>

        <Modal2.Body className="modal_bg_img">

          <Row className="g-4 justify-content-center">

            {/* FREE CALL */}
            <Col xs={6} md={3} className="text-center">

              <div
                className="circle-wrapper"
                onClick={() => handleProceedCall("free")}
              >
                <img src={BgImg} alt="Free Call" className="call-circle" />

                <div className={`circle-overlay ${i18n.language === "ta" ? "tamil-text" : ""}`}>

                  <span>{t("USR.FREE.CALL")}</span>

                  <div className="call-icon">
                    <PiPhoneCallDuotone className="call-phone-icon" />
                  </div>

                  <p className={`circle-label ${i18n.language === "ta" ? "tamil-wallet-text" : ""}`}>
                    (2 {t("TXT.MIN.LO")})
                  </p>

                </div>
              </div>

              <div>
                <img src={UpBtn} className="call-arrow" alt="arrow" />
              </div>
              <span className="circle-hint">{t("USR.TAP.TO.CALL")}</span>

            </Col>


            {/* WALLET CALL */}
            <Col xs={6} md={3} className="text-center">

              <div
                className="circle-wrapper"
                onClick={() => handleProceedCall("wallet")}
              >
                <img src={BgImg} alt="Minute Call" className="call-circle" />

                <div className={`circle-overlay ${i18n.language === "ta" ? "tamil-text" : ""}`}>

                  <span>{t("USR.MIN.CALL")}</span>

                  <div className="call-icon">
                    <PiPhoneCallDuotone className="call-phone-icon" />
                  </div>

                  <p className={`circle-label ${i18n.language === "ta" ? "tamil-wallet-text" : ""}`}>
                    {t("USR.AMT.AVALABLE.TIME")} ₹{walletAmount}
                    <br />
                    {talkTime} {t("USR.MIN.TALK.TIME")}
                  </p>

                </div>
              </div>

              <div>
                <img src={UpBtn} className="call-arrow" alt="arrow" />
              </div>

              <span className="circle-hint">{t("USR.TAP.TO.CALL")}</span>

            </Col>


            {/* 15 MIN */}
            <Col xs={6} md={3} className="text-center">

              <div
                className="circle-wrapper"
                onClick={() => handleDurationRadio(15)}
              >
                <img src={BgImg} alt="15 Minutes" className="call-circle" />

                <div className={`circle-overlay ${i18n.language === "ta" ? "tamil-text" : ""}`}>

                  <span>15 {t("USR.MIN.CALL.HEAD")}</span>

                  <div className="call-icon">
                    <PiPhoneCallDuotone className="call-phone-icon" />
                  </div>

                  <p className="circle-label price">
                    <span className="old-price">₹250</span>
                    <span className="new-price">₹200</span>
                  </p>

                </div>
              </div>

              <div>
                <img src={UpBtn} className="call-arrow" alt="arrow" />
              </div>

              <span className="circle-hint">{t("USR.TAP.TO.CALL")}</span>

            </Col>


            {/* 30 MIN */}
            <Col xs={6} md={3} className="text-center">

              <div
                className="circle-wrapper"
                onClick={() => handleDurationRadio(30)}
              >
                <img src={BgImg} alt="30 Minutes" className="call-circle" />

                <div className={`circle-overlay ${i18n.language === "ta" ? "tamil-text" : ""}`}>

                  <span>30 {t("USR.MIN.CALL.HEAD")}</span>

                  <div className="call-icon">
                    <PiPhoneCallDuotone className="call-phone-icon" />
                  </div>

                  <p className="circle-label price">
                    <span className="old-price">₹500</span>
                    <span className="new-price">₹400</span>
                  </p>

                </div>
              </div>

              <div>
                <img src={UpBtn} className="call-arrow" alt="arrow" />
              </div>

              <span className="circle-hint">{t("USR.TAP.TO.CALL")}</span>

            </Col>

          </Row>

        </Modal2.Body>

        <Modal2.Footer className="justify-content-center">
          <Button className="all_btn1" onClick={closeCallType}>
            {t("TXT.CLO.LO")}
          </Button>
        </Modal2.Footer>

      </Modal2>

      {/* <Modal2
        show={callType}
        backdrop="static"
        keyboard={false}
        onHide={closeCallType}
        centered
        fullscreen
      >
        <Modal2.Header closeButton className="all_background">
          <h4 className="mb-0">{t("USR.CALL.TYPE")}</h4>
        </Modal2.Header>

        <Modal2.Body>
          <Row className="justify-content-center text-center g-3">

           
            <Col lg={3} md={4} sm={6} xs={12} className="d-flex justify-content-center">
              <div
                className="call-card"
                onClick={() => handleProceedCall("free")}
              >
                <div className="call-img-wrapper">

                  <img src={FreeImg} alt="Free Call" className="call-img" />

            
                  <div className="overlay-text top-green">
                    2 {t("TXT.MIN.LO")}
                    {t("USR.FREE.CL")}
                  </div>

                  <div className="overlay-text left-circle">
                    2 {t("TXT.MIN.LO")}
                  </div>

                  <div className="overlay-text right-circle">
                    2 {t("TXT.MIN.LO")}
                  </div>

                </div>

                <div className="call-title">
                  2 {t("TXT.MIN.LO")} <br />
                  {t("USR.FREE.CL")}
                </div>
              </div>
            </Col>


          
            <Col lg={3} md={4} sm={6} xs={12} className="d-flex justify-content-center">
              <div
                className="call-card"
                onClick={() => handleProceedCall("wallet")}
              >

                <div className="call-img-wrapper">

                  <img src={WalletImg} alt="Wallet Call" className="call-img" />

                  <div className="overlay-text top-green">
                    {t("USR.PAID.CL.MIN.BASED")}
                  </div>

                  <div className="overlay-text left-circle">
                    15 {t("TXT.MIN.LO")}
                  </div>

                  <div className="overlay-text right-circle">
                    30 {t("TXT.MIN.LO")}
                  </div>

                </div>

                <div className="call-title">
                  {t("USR.PAID.CL.MIN.BASED")}
                </div>

              </div>
            </Col>


        
            <Col lg={3} md={4} sm={6} xs={12} className="d-flex justify-content-center">
              <div
                className="call-card"
                onClick={() => handleProceedCall("duration")}
              >

                <div className="call-img-wrapper">

                  <img src={FixedDuration} alt="Duration Call" className="call-img" />

                  <div className="overlay-text top-green">
                    {t("USR.PAID.CL.FIX.DUR.BASED")}
                  </div>

                  <div className="overlay-text left-circle">
                    15 {t("TXT.MIN.LO")}
                  </div>

                  <div className="overlay-text right-circle">
                    30 {t("TXT.MIN.LO")}
                  </div>

                </div>

                <div className="call-title">
                  {t("USR.PAID.CL.FIX.DUR.BASED")}
                </div>

              </div>
            </Col>

          </Row>
        </Modal2.Body>
      </Modal2>  */}

      <Row className="d-flex  g-1">
        {ConsultantData ? (
          <>
            {ConsultantData?.professionalAccountStatus == "ACTIVATE" ? (
              <Col md={6} lg={4}>
                <Card
                  className="d-flex professionalCard all_border"
                  key={ConsultantData?.consultantUuid}
                >
                  <Card.Header className="all_border">
                    <div className="d-flex justify-content-between flex-row">
                      <strong>{ConsultantData?.consultantName}</strong>
                      <span style={{ width: "max-content", cursor: "pointer" }}>
                        <ReviewBadge
                          conUuid={ConsultantData?.consultantUuid}
                          conName={ConsultantData?.consultantName}
                          conImgUrl={ConsultantData?.imgUrl}
                          conRating={ConsultantData?.consultantRating}
                        />
                      </span>
                    </div>
                    <div
                      className="mt-2 gap-1"
                      style={{ display: "flex", flexDirection: "row" }}
                    >
                      <div>
                        {ConsultantData?.imgUrl ? (
                          <>
                            <img
                              src={ConsultantData?.imgUrl}
                              style={{
                                borderRadius: "50%",
                                height: "50px",
                                width: "50px",
                                objectFit: "cover",
                              }}
                            />
                          </>
                        ) : (
                          <>
                            <img
                              src={require("../images/noimage.jpg")}
                              style={{
                                borderRadius: "50%",
                                height: "50px",
                                width: "50px",
                                objectFit: "cover",
                              }}
                            />
                          </>
                        )}
                        <div className="mt-2">
                          <b>
                            <span>₹{ConsultantData?.ratePerMin}</span>&nbsp;
                          </b>
                          <del style={{ color: "red" }}>
                            {ConsultantData?.maxRate == 0
                              ? null
                              : `${ConsultantData?.maxRate}/${t("TXT.MIN.LO")}`}
                          </del>
                        </div>
                      </div>

                      <div
                        sm={9}
                        style={{
                          textAlign: "left",
                          display: "flex",
                          flexDirection: "column",
                        }}
                      >
                        <small
                          style={{
                            display: "flex",
                            alignItems: "center",
                          }}
                        >
                          <MdOutlineLanguage />
                          {ConsultantData?.knownLangugae},
                          {ConsultantData?.extraLang}
                        </small>
                        <small
                          style={{
                            display: "flex",
                            alignItems: "center",
                          }}
                        >
                          <BiBadgeCheck />
                          {ConsultantData?.skills},{ConsultantData?.extraSkill}
                        </small>
                        <small>
                          <GrUserExpert />
                          {ConsultantData?.expYear}
                          {t("USR.HOM.CL.TEXT1")}
                        </small>
                        {ConsultantData?.profstatus === 1 &&
                          !freeCallStatus &&
                          ConsultantData?.freeCallMins > 0 &&
                          ConsultantData?.freeCallAccess ? (
                          <small style={{ color: "green", fontWeight: "bold" }}>
                            <span> {t("USR.FREE")} </span>

                            <OverlayTrigger
                              key="top"
                              placement="top"
                              overlay={
                                <Tooltip id={`tooltip-top`}>
                                  <span>
                                    {ConsultantData?.freeCallMins}&nbsp;
                                    {t("USR.MIN.FREE")}{" "}
                                  </span>
                                </Tooltip>
                              }
                            >
                              <u
                                style={{
                                  margin: "0px 5px",
                                  cursor: "pointer",
                                }}
                                onClick={() => {
                                  checkLoginAndGetConsultant(
                                    ConsultantData?.consultantUuid,
                                    ConsultantData?.consultantName,
                                    "freeCall",
                                    ConsultantData?.ratePerMin,
                                  );
                                }}
                              >
                                {t("TXT.CAL.LO")}{" "}
                              </u>
                            </OverlayTrigger>
                            <span style={{ margin: "0px 5px" }}>/</span>
                            {ConsultantData?.consultantUuid ==
                              "8cbd80ed-07ae-4925-aff7-3f34470ea09d" ||
                              ConsultantData?.consultantUuid ==
                              "d187f6a9-28f4-4dc8-89d8-52f464679633" ||
                              ConsultantData?.consultantUuid ==
                              "7357db37-2061-4956-869f-889c9259b6d5" ? null : (
                              <OverlayTrigger
                                key="top"
                                placement="top"
                                overlay={
                                  <Tooltip id={`tooltip-top`}>
                                    <span>
                                      {ConsultantData?.freeCallMins}&nbsp;
                                      {t("USR.MIN.FREE")}{" "}
                                    </span>
                                  </Tooltip>
                                }
                              >
                                <u
                                  style={{ cursor: "pointer" }}
                                  onClick={() => {
                                    checkLoginAndGetConsultant(
                                      ConsultantData?.consultantUuid,
                                      ConsultantData?.consultantName,
                                      "freeChat",
                                      ConsultantData?.ratePerMin,
                                    );
                                  }}
                                >
                                  {t("USR.CHAT.BTN")}
                                </u>
                              </OverlayTrigger>
                            )}
                          </small>
                        ) : null}
                      </div>
                    </div>
                  </Card.Header>
                  <Card.Body className="text-center">
                    <Row>
                      <Col
                        style={{
                          display: "flex",
                          justifyContent: "space-evenly",
                        }}
                      >
                        <OverlayTrigger
                          key="top"
                          placement="top"
                          overlay={
                            <Tooltip id={`tooltip-top`}>
                              {t("TXT.STA.CALL.LO")}
                            </Tooltip>
                          }
                        >
                          <Button
                            className="mt-2 all_btn"
                            size="sm"
                            disabled={
                              ConsultantData?.profstatus === 1 ? false : true
                            }
                            // onClick={() => {
                            //   checkLoginAndGetConsultant(
                            //     ConsultantData?.consultantUuid,
                            //     ConsultantData?.consultantName,
                            //     "Call",
                            //     ConsultantData?.ratePerMin,
                            //   );
                            // }}
                            onClick={async () => {
                              if (!token) {
                                sessionStorage.setItem("openCallModal", "true");
                                sessionStorage.setItem("consultantId", ConsultantData?.consultantUuid);
                                sessionStorage.setItem("consultantName", ConsultantData?.consultantName);
                                navigate("/login");
                                return;
                              }

                              // ensure correct numeric rate
                              const rate = Number(ConsultantData?.ratePerMin);
                              sessionStorage.setItem("consultantId", ConsultantData?.consultantUuid);
                              sessionStorage.setItem("consultantName", ConsultantData?.consultantName);
                              await getWalletBalance(rate);
                              openCallType();

                            }}
                          >
                            {t("USR.HOM.CL.ACTION1")}
                          </Button>
                        </OverlayTrigger>
                        <OverlayTrigger
                          key="top"
                          placement="top"
                          overlay={
                            <Tooltip id={`tooltip-top`}>
                              {t("TXT.DO.SCH.LO")}
                            </Tooltip>
                          }
                        >
                          <Button
                            className="mt-2 all_btn"
                            size="sm"
                            onClick={() => {
                              checkLoginAndGetConsultant(
                                ConsultantData?.consultantUuid,
                                ConsultantData?.consultantName,
                                "Book",
                              );
                            }}
                          >
                            {t("USR.HOM.CL.ACTION2")}
                          </Button>
                        </OverlayTrigger>
                        {ConsultantData?.consultantUuid ==
                          "8cbd80ed-07ae-4925-aff7-3f34470ea09d" ||
                          ConsultantData?.consultantUuid ==
                          "d187f6a9-28f4-4dc8-89d8-52f464679633" ||
                          ConsultantData?.consultantUuid ==
                          "7357db37-2061-4956-869f-889c9259b6d5" ? null : (
                          <OverlayTrigger
                            key="top"
                            placement="top"
                            overlay={
                              <Tooltip id={`tooltip-top`}>
                                {t("USR.START.CHAT")}
                              </Tooltip>
                            }
                          >
                            <Button
                              className="mt-2 all_btn"
                              size="sm"
                              disabled={ConsultantData?.profstatus !== 1}
                              onClick={() => {
                                checkLoginAndGetConsultant(
                                  ConsultantData?.consultantUuid,
                                  ConsultantData?.consultantName,
                                  "Chat",
                                  ConsultantData?.ratePerMin,
                                );
                              }}
                            >
                              {String(loadingId) ===
                                String(ConsultantData?.consultantUuid) && (
                                  <span className="spinner-border spinner-border-sm me-2"></span>
                                )}
                              {t("USR.CHAT.BTN")}
                            </Button>
                          </OverlayTrigger>
                        )}
                      </Col>
                    </Row>
                  </Card.Body>
                  {ConsultantData?.profstatus === 1 ? (
                    <Card.Footer
                      className="text-center all_border"
                      style={{ color: "green", height: 45 }}
                    >
                      <strong>{t("USR.HOM.PR.ONL")}</strong>
                      &nbsp;
                      <Spinner animation="grow" variant="success" size="sm" />
                      {/* <GoProject color="RED" size={20} /> */}
                    </Card.Footer>
                  ) : null}
                  {ConsultantData?.profstatus === 2 ? (
                    <Card.Footer
                      className="text-center all_border"
                      style={{ color: "red", height: 45 }}
                    >
                      <strong>{t("USR.HOM.PR.OFF")}</strong>
                      &nbsp;
                      <GoProject color="RED" size={20} />
                    </Card.Footer>
                  ) : null}
                  {ConsultantData?.profstatus === 3 ? (
                    <Card.Footer
                      className="text-center all_border"
                      style={{ color: "green", height: 45 }}
                    >
                      <strong>{t("USR.HOM.PR.ONCA")}</strong>
                      &nbsp;
                      <Spinner animation="grow" variant="success" size="sm" />
                    </Card.Footer>
                  ) : null}
                </Card>
              </Col>
            ) : null}
          </>
        ) : (
          <center>
            <h5>No Consultant Found</h5>
          </center>
        )}
      </Row>
    </div>
  );
};

export default ConsultantDetails;
